import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../../../style.css";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { UserProvider } from "./contexts/userContext";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo/apolloClient";
import { ErrorBoundary } from "./pages/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

try {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <React.Suspense fallback="loading">
          <Analytics />
          <ApolloProvider client={client}>
            <ErrorBoundary>
              <UserProvider>
                <App />
              </UserProvider>
            </ErrorBoundary>
          </ApolloProvider>
        </React.Suspense>
      </BrowserRouter>
    </React.StrictMode>
  );
} catch (e) {
  console.error(e);
}
